export default __webpack_public_path__ + "static/media/tianmao.2beb3695.webp";